module.exports = __webpack_public_path__ + "img/laba.e07890ba.png";